<div mat-dialog-title>
    <h1>{{'CONTROL.LABEL.QUICK_INIT_APP' | transloco}}</h1>
</div>
<div mat-dialog-content>
    <form [formGroup]="formCreate">
        <div class="mt-4 sm:flex sm:justify-center">
            <mat-form-field class="w-full mr-2" appearance="fill">
                <mat-label>App code</mat-label>
                <input matInput formControlName="appCode" required>
                <mat-error *ngIf="formCreate?.get('appCode')?.invalid">
                    <span *ngIf="formCreate?.get('appCode')?.hasError('required')">
                        {{getErrorMessage('appCode','required') | transloco}}</span>
                    <span
                        *ngIf="!formCreate?.get('appCode')?.hasError('required') && formCreate?.get('appCode')?.hasError('invalidPattern')">
                        {{ getErrorMessage('appCode', 'invalidPattern') | transloco }}</span>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-full" appearance="fill">
                <mat-label>App Url</mat-label>
                <input matInput formControlName="appUrl" required>
                <mat-error *ngIf="formCreate?.get('appUrl')?.invalid">
                    <span *ngIf="formCreate?.get('appUrl')?.hasError('required')">
                        {{ getErrorMessage('appUrl', 'required') | transloco }}</span>
                    <span
                        *ngIf="!formCreate?.get('appUrl')?.hasError('required') && formCreate?.get('appUrl')?.hasError('invalidUrlPattern')">
                        {{ getErrorMessage('appUrl', 'invalidUrlPattern') | transloco }}</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 sm:flex sm:justify-center">
            <mat-form-field class="w-full mr-2" appearance="fill">
                <mat-label>Username</mat-label>
                <input matInput formControlName="username" required>
                <mat-error *ngIf="formCreate?.get('username')?.invalid">
                    <span *ngIf="formCreate?.get('username')?.hasError('required')">
                        {{ getErrorMessage('username', 'required') | transloco }}</span>
                    <span
                        *ngIf="!formCreate?.get('username')?.hasError('required') && formCreate?.get('username')?.hasError('invalidUrlPattern')">
                        {{ getErrorMessage('username', 'invalidUrlPattern') | transloco }}</span>
                </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full" appearance="fill">
                <mat-label>Role name</mat-label>
                <input matInput formControlName="role" required>
                <mat-error *ngIf="formCreate?.get('role')?.invalid">
                    <span *ngIf="formCreate?.get('role')?.hasError('required')">
                        {{ getErrorMessage('role', 'required') | transloco }}</span>
                    <span
                        *ngIf="!formCreate?.get('role')?.hasError('required') && formCreate?.get('role')?.hasError('invalidUrlPattern')">
                        {{ getErrorMessage('role', 'invalidUrlPattern') | transloco }}</span>
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</div>
<div class="flex justify-end gap-2 mt-2">
    <button class="ml-1 w-1/5" mat-stroked-button (click)="cancel()">
        {{'CONTROL.LABEL.CANCEL' | transloco }}
    </button>
    <button class="ml-1 w-1/5" mat-flat-button (click)="createApp()" color="primary" [disabled]="formCreate?.invalid">
        {{'CONTROL.LABEL.CREATE' | transloco}}
    </button>
</div>